import React from "react";
import { Link } from "react-router-dom";
import { Page } from "@/components/Layout";
import { useConsultModal } from "@/components/ConsultModal";
import { ArrowRight, CheckCircle } from "@phosphor-icons/react";

const problemTags = [
  "I cannot focus no matter how hard I try", "My mind goes blank at the worst times", "I overthink everything and cannot decide",
  "I am exhausted but I have not done anything", "I forget things I should not forget", "I know I am capable but I am not performing like it",
  "Stress completely shuts my brain down", "I cannot juggle more than one thing at a time", "My brain feels like it is running on low battery",
  "I think I have ADHD but have never been assessed", "My brain has not been the same since COVID", "I am recovering from a stroke or brain injury",
  "My illness is affecting how I think", "My thinking changed and I think it is hormonal", "I am doing fine on paper but something feels off",
  "I know something is wrong but nobody has a name for it",
];

const journey = [
  { step: "01", title: "Knowing You", desc: "An in-depth conversation with Shreeja to map your story, context and goals." },
  { step: "02", title: "Assessment", desc: "Structured neuropsych and cognitive assessments tailored to your concerns." },
  { step: "03", title: "Therapy or Coaching Package", desc: "A personalised programme, therapy, coaching or both, to move forward." },
];

export default function CognitiveSupport() {
  const { open: openConsult } = useConsultModal();
  return (
    <Page>
      <section className="md-section md-page-hero">
        <div className="md-container">
          <div className="md-label-eyebrow mb-4">Cognitive & Neuropsych Support</div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif">The Structured Pathway with <em>Shreeja Reddy</em></h1>
          <p className="text-base mt-5 max-w-2xl mx-auto">
            For when something about your thinking feels off, and you want someone to take it seriously. A founder-led, three-step process.
          </p>
        </div>
      </section>

      <section className="md-section pt-0">
        <div className="md-container">
          <h2 className="text-3xl font-serif mb-8 text-center">Does any of this sound like you?</h2>
          <div className="grid md:grid-cols-2 gap-3">
            {problemTags.map((t) => (
              <div key={t} className="flex items-start gap-3 p-4 rounded-lg bg-white border" style={{ borderColor: "var(--md-border)" }}>
                <CheckCircle size={18} weight="duotone" className="mt-0.5 shrink-0" style={{ color: "var(--md-accent)" }} />
                <p className="text-sm">{t}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="md-section md-journey-section" data-testid="your-journey-section">
        <div className="md-container">
          <h2 className="text-4xl md:text-5xl font-serif mb-12 md-page-title-center">Your Journey</h2>
          <div className="grid md:grid-cols-3 gap-6">
            {journey.map((j) => (
              <div key={j.step} className="md-card md-journey-card">
                <div className="wordmark text-4xl" style={{ color: "var(--md-accent)" }}>{j.step}</div>
                <h3 className="text-2xl font-serif mt-4">{j.title}</h3>
                <p className="mt-3 text-sm" style={{ color: "var(--md-text-soft)" }}>{j.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-12 text-center">
            <button onClick={openConsult} className="btn-primary" data-testid="cognitive-start-pathway">Start the Structured Pathway <ArrowRight size={14} weight="bold" /></button>
          </div>
        </div>
      </section>
    </Page>
  );
}
